// File for logic corresponding to dropzone-widget component
import { Component } from 'js-component-framework';
/**
 * Component for dropzone widgets.
 */
export default class DropzoneWidget extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.hasSendToNewsEmbed = this.hasSendToNewsEmbed.bind(this);
    this.removeClass = this.removeClass.bind(this);

    if (this.hasSendToNewsEmbed()) {
      const { zIndexStackingResetClass } = this.options;
      /*
       * A Send To News player within a Custom HTML widget should be allowed to
       * us it's own z-index. See NXS-3231.
       */
      this.removeClass(zIndexStackingResetClass);
    }
  }

  /**
   * Determine if this widget contains a Send to News embed.
   *
   * @returns {boolean}
   */
  hasSendToNewsEmbed() {
    const { customHtmlWidget } = this.children;
    const s2nPlayer = customHtmlWidget?.querySelector(
      'script[data-type="s2nScript"]',
    ) ?? null;

    if (! s2nPlayer) {
      return false;
    }
    return true;
  }

  /**
   * Remove a class from the widget.
   *
   * @param {String} $classToRemove
   */
  removeClass($classToRemove) {
    if (! this.element.classList.contains($classToRemove)) {
      // eslint-disable-next-line no-console
      console.error(
        `${this.element} does not contain the class ${$classToRemove}`,
      );
      return;
    }
    this.element.classList.remove($classToRemove);
  }
}
